import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=82fc5fde&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=82fc5fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fc5fde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82fc5fde')) {
      api.createRecord('82fc5fde', component.options)
    } else {
      api.reload('82fc5fde', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=82fc5fde&scoped=true&", function () {
      api.rerender('82fc5fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UsFQbjA80HTi/JS/comp/DocBox.vue"
export default component.exports